export type LoanOfferResponse = {
  averageMonthlyRevenue: number;
  maximumHoldback: number;
  maximumLoanAmount: number;
  maximumTerm: number;
  minimumHoldback: number;
  minimumLoanAmount: number;
  minimumMonthlyFactorRate: number;
  minimumTerm: number;
  cifNumber: string;
  externalId: string;
  expiryDate: string;
  startDate: string;
  id: number;
  status: string | null;
  creditStatus: string;
  createdDate: string;
  suggestedHoldBack: number;
  suggestedLoanAmount: number;
  hasAugendLastedQuote: boolean;
};
